import { Pipe, PipeTransform } from '@angular/core';

import { ChipVariants } from '../../shared/components/chip/chip.component';
import { ÉTAT_GROUPE } from '../enum/état-groupe.enum';

@Pipe({
  name: 'getEtatGroupeVariant',
})
export class GetEtatGroupeVariantPipe implements PipeTransform {
  transform(état?: ÉTAT_GROUPE): ChipVariants['variant'] {
    switch (état) {
      case ÉTAT_GROUPE.A_FAIRE:
        return 'default';
      case ÉTAT_GROUPE.A_VALIDER:
        return 'informative';
      case ÉTAT_GROUPE.VALIDE:
        return 'positive';
      case ÉTAT_GROUPE.REJETE:
        return 'negative';
      default:
        return 'default';
    }
  }
}
